// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   TextField,
//   MenuItem,
//   Button,
//   FormControl,
//   RadioGroup,
//   Radio,
//   FormControlLabel,
//   Divider,
//   Grid,
// } from "@mui/material";

// import DevOpsandSRE from "../assets/images/DevOpsandSRE.png";
// import logo from "../assets/images/logo.svg";

// import { useApi } from "../api/useApi";
// import { AnimatePresence, motion } from "framer-motion";
// import Notification from "./Notification";
// import { useNavigate } from "react-router-dom";
// import GlassLoaderOverLay from "./GlassLoader";
// import { ReactComponent as DomainArrowIcon } from "../assets/images/Vector.svg";
// import { API_PATH } from "../environments";
// import { Checkbox, FormGroup, FormLabel } from "@mui/material";
// import { useLocation } from "react-router-dom";

// import PhoneInput from "react-country-phone-input";
// import "react-country-phone-input/lib/style.css";
// import { phonePatterns } from "./PhonePatterns";
// const SuccessBanner = ({ open, message, status }) => {
//   return (
//     <AnimatePresence>
//       {open && (
//         <motion.div
//           initial={{ y: 50, opacity: 0 }}
//           animate={{ y: 0, opacity: 1 }}
//           exit={{ y: 50, opacity: 0 }}
//           transition={{ duration: 0.4, ease: "easeOut" }}
//           style={{
//             position: "fixed",
//             bottom: "2rem",
//             left: "35%",
//             transform: "translateX(-50%)",
//             display: "inline-flex",
//             alignItems: "center",
//             gap: "1rem",
//             borderRadius: "1rem",
//             border: status ? "1px solid #eb3d2e" : "1px solid #00A300",
//             background: status ? "#df4c4c" : "#016100",
//             color: "#FFFFFF",
//             fontFamily: "Akkurat-Bold, sans-serif",
//             fontSize: "0.9rem",
//             fontWeight: 400,
//             padding: "0.75rem 1.25rem",
//             zIndex: 2000,
//             boxShadow: "0 2px 10px rgba(0, 0, 0, 0.25)",
//             textAlign: "center",
//             maxWidth: "90%",
//           }}
//         >
//           {status?(<svg
//             xmlns="http://www.w3.org/2000/svg"
//             width="20"
//             height="20"
//             viewBox="0 0 20 20"
//             fill="none"
//           >
//             <path
//               fillRule="evenodd"
//               clipRule="evenodd"
//               d="M10 1.25C5.125 1.25 1.25 5.125 1.25 10C1.25 14.875 5.125 18.75 10 18.75C14.875 18.75 18.75 14.875 18.75 10C18.75 5.125 14.875 1.25 10 1.25ZM8.75 13.75L5.375 10.375L6.5 9.375L8.75 11.625L13.75 6.75L14.875 7.75L8.75 13.75Z"
//               fill="#f7980a"
//             />
//           </svg>):(<svg
//             xmlns="http://www.w3.org/2000/svg"
//             width="20"
//             height="20"
//             viewBox="0 0 20 20"
//             fill="none"
//           >
//             <path
//               fillRule="evenodd"
//               clipRule="evenodd"
//               d="M10 1.25C5.125 1.25 1.25 5.125 1.25 10C1.25 14.875 5.125 18.75 10 18.75C14.875 18.75 18.75 14.875 18.75 10C18.75 5.125 14.875 1.25 10 1.25ZM8.75 13.75L5.375 10.375L6.5 9.375L8.75 11.625L13.75 6.75L14.875 7.75L8.75 13.75Z"
//               fill="#24A148"
//             />
//           </svg>)}

//           <span>{message}</span>
//         </motion.div>
//       )}
//     </AnimatePresence>
//   );
// };

// export default function ContactusPage() {
//   const { request, loading } = useApi();
//   const location = useLocation();
//   const [responseMessage, setResponseMessage] = useState("");
//   const [error, setError] = useState("");
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [openSuccess, setOpenSuccess] = useState(false);
//   const navigate = useNavigate();
//   const [showSuccessBanner, setShowSuccessBanner] = useState(false);
//   const [showErrorBanner, setShowErrorBanner] = useState(false);
//   const [bannerMessage, setBannerMessage] = useState("");
//   const [phoneNumber, setPhoneNumber] = useState(
//     location?.state?.phone ? location?.state?.phone : "",
//   );
//   const [phoneError, setPhoneError] = useState("");
//   const [domainOptions, setDomainOptions] = useState([]);
//   const [errors, setErrors] = useState({});
//   const [userLoged,setUserLoged] = useState(location?.state?.userLogedIn?location?.state?.userLogedIn:false)
//   const [formData, setFormData] = useState({
//     name: location?.state?.name ? location?.state?.name : "",
//     email: location?.state?.email ? location?.state?.email : "",
//     phone: location?.state?.phone ? location?.state?.phone : "",
//     domain: location?.state?.userDomain ? location?.state?.userDomain : "",
//     role: location?.state?.userRole ? location?.state?.userRole : "",
//     category: "",
//     remarks: location?.state?.remarks ? location?.state?.remarks : "",
//     organisation: location?.state?.organisation
//       ? location?.state?.organisation
//       : "",
//     jobTitle: location?.state?.jobTitle ? location?.state?.jobTitle : "",
//     // remarks: "",
//     // organisation: "",
//     // jobTitle: "",
//     emailContact: false,
//     phoneContact: false,
//   });

//   const [notif, setNotif] = useState({
//     open: false,
//     success: true,
//     text: "",
//   });
//   function validatePhone(phone, countryCode) {
//     const digits = phone.replace(/\D/g, "");
//     const entry = phonePatterns[countryCode?.toUpperCase()];
//     if (!entry) return null;
//     return entry.pattern.test(digits);
//   }
//   const handlePhoneChange = (value, countryData) => {
//     setPhoneNumber(value ?? "");
//     const iso = countryData?.countryCode?.toUpperCase();
//     const dialCode = countryData?.dialCode ?? "";
//     const localNumber = (value ?? "").replace(/\D/g, "").slice(dialCode.length);
//     const valid = validatePhone(localNumber, iso);
//     setPhoneError(
//       valid === false
//         ? `Invalid ${countryData?.name} number — ${phonePatterns[iso]?.hint}`
//         : "",
//     );
//   };
//   // Fetch domain roles
//   useEffect(() => {
//     request({ url: "/domain-roles", method: "GET" })
//       .then((res) => setDomainOptions(res))
//       .catch(() =>
//         setNotif({
//           open: true,
//           success: false,
//           text: "Failed to load domain options.",
//         }),
//       );
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     console.log(name, value);
//     setFormData((prev) => ({ ...prev, [name]: value }));
//     setErrors((prev) => ({ ...prev, [name]: "" }));
//   };
//   const handleCheckBoxChange = (e) => {
//     const { name, value, checked } = e.target;
//     console.log("name =>", name, value, checked);
//     setFormData((prev) => ({ ...prev, [name]: checked }));
//   };
//   const validate = () => {
//     const newErrors = {};

//     if (!formData.name.trim()) newErrors.name = "Full Name is required";

//     if (!formData.email.trim()) newErrors.email = "Email is required";
//     else if (!/^\S+@\S+\.\S+$/.test(formData.email))
//       newErrors.email = "Invalid email format";

//     if (!phoneNumber.trim()) newErrors.phone = "Phone number is required";
//     else if (phoneError) newErrors.phone = phoneError;

//     if (!formData.domain) newErrors.domain = "Domain is required";
//     if (!formData.role) newErrors.role = "Role is required";
//     if (!formData.organisation)
//       newErrors.organisation = "organisation is required";
//     if (!formData.jobTitle) newErrors.jobTitle = "jobTitle is required";
//     if (!formData.remarks.trim()) newErrors.remarks = "Please enter your query";
//     if (!(formData?.emailContact | formData?.phoneContact))
//       newErrors.contactPreference = "Contact Preference is required";

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;

//     const payload = {
//       userName: formData.name,
//       emailId: formData.email,
//       phoneNumber: phoneNumber,
//       userDomain: formData.domain,
//       domain: formData.category, // DevOps or SRE
//       userRole: formData.role,
//       remarks: formData.remarks,
//       fromContactUs: true,
//       userCategory: "user",
//       organisation: formData?.organisation,
//       jobTitle: formData?.jobTitle,
//       contactPreference:
//         formData?.emailContact && formData?.phoneContact
//           ? "Email,Phone"
//           : formData?.phoneContact
//             ? "Phone"
//             : formData?.emailContact
//               ? "Email"
//               : "",
//     };
//     // http://localhost:8085/api/user/add
//     try {
//       // const response = await fetch("http://localhost:8085/api/user/add", {
//       const response = await fetch(`${API_PATH}/user/add`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });

//       if (response.ok) {
//         setBannerMessage(
//           "Thank you! Our team will reach out within 24 working hours.",
//         );
//         setShowErrorBanner(false);
//         setShowSuccessBanner(true);
//         setTimeout(() => setShowSuccessBanner(false), 3000);
//         setTimeout(() => setShowErrorBanner(false), 3000);

//         setFormData({
//           name: "",
//           email: "",
//           phone: "",
//           domain: "",
//           role: "",
//           category: "",
//           remarks: "",
//           organisation: "",
//           jobTitle: "",
//           emailContact: false,
//           phoneContact: false,
//         });
//         setPhoneNumber();
//       } else {
//         setShowErrorBanner(true);
//         setBannerMessage("Something went wrong. Please try again");
//         setShowSuccessBanner(true);
//         setTimeout(() => setShowSuccessBanner(false), 3000);
//         setTimeout(() => setShowErrorBanner(false), 3000);
//       }
//     } catch (err) {
//       setShowErrorBanner(true);
//       setBannerMessage("Unable to submit. Try again later.");
//       setShowSuccessBanner(true);
//       setTimeout(() => setShowSuccessBanner(false), 3000);
//       setTimeout(() => setShowErrorBanner(false), 3000);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         width: "100%",
//         height: "100vh",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         background: "#F5F6F8",
//       }}
//     >
//       {/* Outer Frame */}
//       <Box
//         sx={{
//           display: "flex",
//           width: { xs: "80vw", md: "60vw", xl: "65vw" },
//           height: { xs: "82vh", md: "72vh", xl: "75vh" },
//           borderRadius: "1.25rem",
//           border: "1px solid #E0E0E0",
//           backgroundColor: "#FFF",
//           padding: "32px 16px",
//           gap: 3,
//         }}
//       >
//         {/* Left Image */}
//         <Box
//           sx={{
//             width: "50%",
//             display: "flex",
//             alignItems: "flex-start",
//             justifyContent: "center",
//           }}
//         >
//           <Box
//             component="img"
//             src={DevOpsandSRE}
//             alt="Illustration"
//             sx={{
//               width: "100%",
//               height: "100%",
//               objectFit: "contain",
//             }}
//           />
//         </Box>

//         {/* Right Content */}
//         <Box
//           sx={{
//             width: "47%",
//             display: "flex",
//             flexDirection: "column",
//             overflowY: "scroll",
//             scrollbarWidth: "none",
//             "&::-webkit-scrollbar": { display: "none" },
//           }}
//         >
//           {/* Logo */}
//           <Box
//             component="img"
//             src={logo}
//             alt="Sandhata Logo"
//             sx={{
//               width: { xs: "162px", xl: "150px" },
//               height: { xs: "30px", xl: "35px" },
//               objectFit: "contain",
//               mb: 2,
//             }}
//           />

//           {/* Title */}
//           <Typography
//             sx={{
//               color: "#0036DD",
//               fontFamily: "Akkurat-Bold",
//               fontWeight: 400,
//               fontSize: {
//                 xs: "1rem",
//                 sm: "1rem",
//                 md: "1rem",
//                 lg: "18px",
//                 xl: "1rem",
//               },
//               //mb: 0.5,
//             }}
//           >
//             DevOps and SRE Portal
//           </Typography>

//           <Typography
//             sx={{
//               color: "#525252",
//               fontFamily: "Akkurat-Pro",
//               fontWeight: 400,
//               fontSize: {
//                 xs: "0.7rem",
//                 sm: "0.7rem",
//                 md: "0.7rem",
//                 lg: "12px",
//                 xl: "0.8rem",
//               },
//               mb: 3,
//             }}
//           >
//             Looking for a DevOps or SRE solution? Fill out the form below, and
//             we’ll get back to you within 24 working hours.
//           </Typography>

//           {/* FULL NAME */}
//           <Box sx={{ mb: 2 }}>
//             <Typography
//               sx={{
//                 mb: 0.5,
//                 fontFamily: "Akkurat-Pro",
//                 fontSize: {
//                   xs: "0.8rem",
//                   sm: "0.8rem",
//                   md: "0.8rem",
//                   lg: "0.75rem",
//                   xl: "0.9rem",
//                 },
//                 color: "#525252",
//               }}
//             >
//               Full Name*
//             </Typography>

//             <TextField
//               name="name"
//               value={formData.name}
//               onChange={handleChange}
//               placeholder="John Doe"
//               variant="standard"
//               slotProps={{ input: { disableUnderline: true } }}
//               sx={{
//                 borderRadius: "1.75rem",
//                 border: "1px solid #E0E0E0",
//                 px: 2,
//                 py: 0.5,
//                 width: "90%",
//                 height: "25px",
//                 "& .MuiInputBase-input": {
//                   fontSize: "0.82rem",
//                 },

//                 "& input:-webkit-autofill": {
//                   WebkitBoxShadow: "0 0 0 1000px #FFFFFF inset",
//                   WebkitTextFillColor: "#000",
//                   caretColor: "#000",
//                   transition: "background-color 9999s ease-out 0s",
//                 },
//                 "& .MuiTypography-root": {
//                   fontFamily: "Akkurat",
//                 },
//               }}
//             />

//             {errors.name && (
//               <Typography sx={{ color: "red", fontSize: "0.75rem" }}>
//                 {errors.name}
//               </Typography>
//             )}
//           </Box>

//           {/* EMAIL */}
//           <Box sx={{ mb: 2 }}>
//             <Typography
//               sx={{
//                 mb: 0.5,
//                 fontSize: {
//                   xs: "0.8rem",
//                   sm: "0.8rem",
//                   md: "0.8rem",
//                   lg: "0.75rem",
//                   xl: "0.9rem",
//                 },
//                 color: "#525252",
//               }}
//             >
//               Business Email*
//             </Typography>

//             <TextField
//               name="email"
//               value={formData.email}
//               onChange={handleChange}
//               placeholder="i.e. john.doe@sandhata.com"
//               variant="standard"
//               slotProps={{ input: { disableUnderline: true } }}
//               sx={{
//                 borderRadius: "1.75rem",
//                 border: "1px solid #E0E0E0",
//                 px: 2,
//                 py: 0.5,
//                 width: "90%",
//                 height: "25px",
//                 "& .MuiInputBase-input": {
//                   fontSize: "0.82rem",
//                 },
//                 "& .MuiTypography-root": {
//                   fontFamily: "Montserrat",
//                 },
//                 "& input:-webkit-autofill": {
//                   WebkitBoxShadow: "0 0 0 1000px #FFFFFF inset",
//                   WebkitTextFillColor: "#000",
//                   caretColor: "#000",
//                   transition: "background-color 9999s ease-out 0s",
//                 },
//               }}
//             />

//             {errors.email && (
//               <Typography
//                 sx={{
//                   color: "red",
//                   fontSize: {
//                     xs: "0.8rem",
//                     sm: "0.8rem",
//                     md: "0.8rem",
//                     lg: "0.8rem",
//                     xl: "0.9rem",
//                   },
//                 }}
//               >
//                 {errors.email}
//               </Typography>
//             )}
//           </Box>
//           {/* ORGANISATION */}
//           <Box sx={{ mb: 2 }}>
//             <Typography
//               sx={{
//                 mb: 0.5,
//                 fontFamily: "Akkurat-Pro",
//                 fontSize: {
//                   xs: "0.8rem",
//                   sm: "0.8rem",
//                   md: "0.8rem",
//                   lg: "0.75rem",
//                   xl: "0.9rem",
//                 },
//                 color: "#525252",
//               }}
//             >
//               Organisation *
//             </Typography>

//             <TextField
//               name="organisation"
//               value={formData.organisation}
//               onChange={handleChange}
//               placeholder="Sandhata"
//               variant="standard"
//               slotProps={{ input: { disableUnderline: true } }}
//               sx={{
//                 borderRadius: "1.75rem",
//                 border: "1px solid #E0E0E0",
//                 px: 2,
//                 py: 0.5,
//                 width: "90%",
//                 height: "25px",
//                 "& .MuiInputBase-input": {
//                   fontSize: "0.82rem",
//                 },

//                 "& input:-webkit-autofill": {
//                   WebkitBoxShadow: "0 0 0 1000px #FFFFFF inset",
//                   WebkitTextFillColor: "#000",
//                   caretColor: "#000",
//                   transition: "background-color 9999s ease-out 0s",
//                 },
//                 "& .MuiTypography-root": {
//                   fontFamily: "Akkurat",
//                 },
//               }}
//             />

//             {errors.organisation && (
//               <Typography sx={{ color: "red", fontSize: "0.75rem" }}>
//                 {errors.organisation}
//               </Typography>
//             )}
//           </Box>
//           {/* JOB TITLE */}
//           <Box sx={{ mb: 2 }}>
//             <Typography
//               sx={{
//                 mb: 0.5,
//                 fontFamily: "Akkurat-Pro",
//                 fontSize: {
//                   xs: "0.8rem",
//                   sm: "0.8rem",
//                   md: "0.8rem",
//                   lg: "0.75rem",
//                   xl: "0.9rem",
//                 },
//                 color: "#525252",
//               }}
//             >
//               Job Title *
//             </Typography>

//             <TextField
//               name="jobTitle"
//               value={formData.jobTitle}
//               onChange={handleChange}
//               placeholder="Engineer"
//               variant="standard"
//               slotProps={{ input: { disableUnderline: true } }}
//               sx={{
//                 borderRadius: "1.75rem",
//                 border: "1px solid #E0E0E0",
//                 px: 2,
//                 py: 0.5,
//                 width: "90%",
//                 height: "25px",
//                 "& .MuiInputBase-input": {
//                   fontSize: "0.82rem",
//                 },

//                 "& input:-webkit-autofill": {
//                   WebkitBoxShadow: "0 0 0 1000px #FFFFFF inset",
//                   WebkitTextFillColor: "#000",
//                   caretColor: "#000",
//                   transition: "background-color 9999s ease-out 0s",
//                 },
//                 "& .MuiTypography-root": {
//                   fontFamily: "Akkurat",
//                 },
//               }}
//             />

//             {errors.jobTitle && (
//               <Typography sx={{ color: "red", fontSize: "0.75rem" }}>
//                 {errors.jobTitle}
//               </Typography>
//             )}
//           </Box>
//           {/* PHONE NUMBER */}

//           <Box sx={{ mb: 2 }}>
//             <Typography
//               sx={{
//                 mb: 0.5,
//                 fontSize: {
//                   xs: "0.8rem",
//                   sm: "0.8rem",
//                   md: "0.8rem",
//                   lg: "0.8rem",
//                   xl: "0.9rem",
//                 },
//                 color: "#525252",
//               }}
//             >
//               Phone Number*
//             </Typography>

//             {/* <TextField
//               name="phone"
//               value={formData.phone}
//               onChange={handleChange}
//               placeholder="+911234567890"
//               variant="standard"
//               slotProps={{ input: { disableUnderline: true } }}
//               sx={{
//                 borderRadius: "1.75rem",
//                 border: "1px solid #E0E0E0",
//                 px: 2,
//                 py: 0.5,
//                 width: "90%",
//                 height: "25px",
//                 "& .MuiInputBase-input": {
//                   fontSize: "0.82rem",
//                 },

//                 "& input:-webkit-autofill": {
//                   WebkitBoxShadow: "0 0 0 1000px #FFFFFF inset",
//                   WebkitTextFillColor: "#000",
//                   caretColor: "#000",
//                   transition: "background-color 9999s ease-out 0s",
//                 },
//               }}
//             /> */}

//             {/* <Box
//               sx={{
//                 width: "90%",
//                 border: "1px solid #E0E0E0",
//                 borderRadius: "1.75rem",
//                 px: 2,
//                 height: "35px",
//                 display: "flex",
//                 alignItems: "center",

//                 "& .PhoneInput": {
//                   width: "100%",
//                 },

//                 "& .PhoneInputInput": {
//                   border: "none",
//                   outline: "none",
//                   fontSize: "1.12rem",
//                   width: "100%",
//                   background: "transparent",
//                 },

//                 "& .PhoneInputCountry": {
//                   marginRight: "8px",
//                 },
//               }}
//             >
//               <PhoneInput
//                 placeholder="Enter phone number"
//                 value={phoneNumber}
//                 onChange={setPhoneNumber}
//                 country="US"
//               /> */}

//             <PhoneInput
//               country="us"
//               value={phoneNumber}
//               onChange={handlePhoneChange}
//               enableSearch={true}
//               countryCodeEditable={false}
//               inputStyle={{
//                 width: "95%",
//                 borderRadius: "18px",
//                 fontSize: "15px",
//               }}
//               buttonStyle={{
//                 borderRadius: "18px 0 0 18px",
//                 borderRight: "none",
//               }}
//               containerStyle={{
//                 width: "100%",
//               }}
//             />
//             {/* </Box> */}

//             {/* <Typography
//               sx={{
//                 color: "#525252",
//                 fontSize: {
//                   xs: "0.8rem",
//                   sm: "0.8rem",
//                   md: "0.8rem",
//                   lg: "0.6rem",
//                   xl: "0.9rem",
//                 },
//                 color: "#525252",
//               }}
//             >
//               Include country code
//             </Typography> */}

//             {errors.phone && (
//               <Typography
//                 sx={{
//                   color: "red",
//                   fontSize: {
//                     xs: "0.8rem",
//                     sm: "0.8rem",
//                     md: "0.8rem",
//                     lg: "0.8rem",
//                     xl: "0.9rem",
//                   },
//                 }}
//               >
//                 {errors.phone}
//               </Typography>
//             )}
//           </Box>
//           <Box>
//             <FormControl>
//               <Typography
//                 sx={{
//                   mb: 0.5,
//                   fontSize: {
//                     xs: "0.8rem",
//                     sm: "0.8rem",
//                     md: "0.8rem",
//                     lg: "0.8rem",
//                     xl: "0.9rem",
//                   },
//                   color: "#525252",
//                 }}
//               >
//                 Contact Preference *
//               </Typography>
//               <FormGroup>
//                 <FormControlLabel
//                   control={
//                     <Checkbox
//                       checked={formData?.emailContact}
//                       onChange={handleCheckBoxChange}
//                       name="emailContact"
//                     />
//                   }
//                   sx={{
//                     color: "#525252",
//                     "& .MuiTypography-root": {
//                       fontFamily: "Akkurat",
//                       fontSize: {
//                         xs: "0.7rem",
//                         sm: "0.7rem",
//                         md: "0.7rem",
//                         lg: "0.7rem",
//                         xl: "0.8rem",
//                       },
//                     },
//                   }}
//                   label="Email"
//                 />
//                 <FormControlLabel
//                   sx={{
//                     color: "#525252",
//                     "& .MuiTypography-root": {
//                       fontFamily: "Akkurat",
//                       fontSize: {
//                         xs: "0.7rem",
//                         sm: "0.7rem",
//                         md: "0.7rem",
//                         lg: "0.7rem",
//                         xl: "0.8rem",
//                       },
//                     },
//                   }}
//                   control={
//                     <Checkbox
//                       checked={formData?.phoneContact}
//                       onChange={handleCheckBoxChange}
//                       name="phoneContact"
//                     />
//                   }
//                   label="Phone"
//                 />
//               </FormGroup>

//             </FormControl>

//             {errors.contactPreference && (
//               <Typography sx={{ color: "red", fontSize: "0.75rem" }}>
//                 {errors.contactPreference}
//               </Typography>
//             )}
//           </Box>
//           {/* DOMAIN */}
//           <Box sx={{ mb: 2 }}>
//             <Typography
//               sx={{
//                 mb: 0.5,
//                 fontSize: {
//                   xs: "0.8rem",
//                   sm: "0.8rem",
//                   md: "0.8rem",
//                   lg: "0.8rem",
//                   xl: "0.9rem",
//                 },
//                 color: "#525252",
//               }}
//             >
//               Domain*
//             </Typography>

//             <TextField
//               select
//               name="domain"
//               value={formData.domain}
//               onChange={handleChange}
//               variant="standard"
//               SelectProps={{
//                 IconComponent: DomainArrowIcon,
//               }}
//               slotProps={{ input: { disableUnderline: true } }}
//               sx={{
//                 borderRadius: "1.75rem",
//                 border: "1px solid #E0E0E0",
//                 px: 2,
//                 py: 0.5,
//                 width: "90%",
//                 height: "25px",
//                 "& .MuiInputBase-input": {
//                   fontSize: "0.82rem",
//                 },
//                 "& .MuiTypography-root": {
//                   fontFamily: "Montserrat",
//                 },
//                 "& .MuiSelect-icon": {
//                   right: "12px", // Position arrow
//                   top: "50%",
//                   transform: "translateY(-50%)",
//                   width: "0.7rem", // match your SVG size
//                   height: "0.8rem",
//                   pointerEvents: "none",
//                 },
//               }}
//             >
//               <MenuItem
//                 value=""
//                 sx={{
//                   fontSize: {
//                     xs: "0.7rem",
//                     sm: "0.7rem",
//                     md: "0.7rem",
//                     lg: "0.7rem",
//                     xl: "0.8rem",
//                   },
//                   color: "#525252",
//                   "& .MuiTypography-root": {
//                     fontFamily: "Montserrat",
//                   },
//                 }}
//               >
//                 Choose one option
//               </MenuItem>

//               {domainOptions.map((opt) => (
//                 <MenuItem
//                   key={opt.roleName}
//                   value={opt.roleName}
//                   sx={{
//                     fontSize: {
//                       xs: "0.7rem",
//                       sm: "0.7rem",
//                       md: "0.7rem",
//                       lg: "0.7rem",
//                       xl: "0.8rem",
//                     },
//                     color: "#525252",
//                     "& .MuiTypography-root": {
//                       fontFamily: "Montserrat",
//                     },
//                   }}
//                 >
//                   {opt.roleName}
//                 </MenuItem>
//               ))}
//             </TextField>

//             {errors.domain && (
//               <Typography
//                 sx={{
//                   color: "red",
//                   fontSize: {
//                     xs: "0.8rem",
//                     sm: "0.8rem",
//                     md: "0.8rem",
//                     lg: "0.8rem",
//                     xl: "0.8rem",
//                   },
//                   "& .MuiTypography-root": {
//                     fontFamily: "Montserrat",
//                   },
//                 }}
//               >
//                 {errors.domain}
//               </Typography>
//             )}
//           </Box>

//           {/* ROLE + CATEGORY grouped */}
//           <Box sx={{ display: "flex", flexDirection: "row", mb: 2 }}>
//             <Box sx={{ mr: 10 }}>
//               <Typography
//                 sx={{
//                   mb: 0.5,
//                   fontSize: {
//                     xs: "0.8rem",
//                     sm: "0.8rem",
//                     md: "0.8rem",
//                     lg: "0.8rem",
//                     xl: "0.8rem",
//                   },
//                   color: "#525252",
//                   "& .MuiTypography-root": {
//                     fontFamily: "Akkurat-Pro",
//                   },
//                 }}
//               >
//                 Role*
//               </Typography>

//               <FormControl>
//                 <RadioGroup
//                   row
//                   name="role"
//                   value={formData.role}
//                   onChange={handleChange}
//                   sx={{ display: "flex", flexDirection: "column" }}
//                 >
//                   <FormControlLabel
//                     value="Manager"
//                     sx={{
//                       color: "#525252",
//                       "& .MuiTypography-root": {
//                         fontFamily: "Akkurat",
//                         fontSize: {
//                           xs: "0.7rem",
//                           sm: "0.7rem",
//                           md: "0.7rem",
//                           lg: "0.7rem",
//                           xl: "0.8rem",
//                         },
//                       },
//                     }}
//                     control={<Radio />}
//                     label="Manager"
//                   />
//                   <FormControlLabel
//                     value="Technical"
//                     control={<Radio />}
//                     label="Technical"
//                     sx={{
//                       color: "#525252",
//                       "& .MuiTypography-root": {
//                         fontFamily: "Akkurat",
//                         fontSize: {
//                           xs: "0.7rem",
//                           sm: "0.7rem",
//                           md: "0.7rem",
//                           lg: "0.7rem",
//                           xl: "o.8rem",
//                         },
//                       },
//                     }}
//                   />
//                 </RadioGroup>
//               </FormControl>

//               {errors.role && (
//                 <Typography
//                   sx={{
//                     color: "red",
//                     fontSize: {
//                       xs: "0.9rem",
//                       sm: "0.9rem",
//                       md: "0.9rem",
//                       lg: "0.9rem",
//                       xl: "0.8rem",
//                     },
//                   }}
//                 >
//                   {errors.role}
//                 </Typography>
//               )}
//             </Box>

//             {/* CATEGORY (DevOps / SRE) */}
//           </Box>
//           {/* QUERY BOX */}
//           <Box sx={{ mb: 2 }}>
//             <Typography
//               sx={{
//                 mb: 0.5,
//                 color: "#525252",
//                 fontSize: "12px",
//                 fontFamily: "Akkurat-Pro",
//                 fontWeight: 400,
//               }}
//             >
//               How can we help you?*
//             </Typography>

//             <TextField
//               multiline
//               minRows={3}
//               name="remarks"
//               value={formData.remarks}
//               onChange={handleChange}
//               placeholder="Enter your query"
//               sx={{
//                 width: "90%",
//                 "& .MuiOutlinedInput-root": {
//                   background: "white",
//                   borderRadius: "0.75rem",

//                   // 🔹 Default border color
//                   "& fieldset": {
//                     borderColor: "#D9D9D9",
//                   },

//                   // 🔹 Prevent border color change on hover
//                   "&:hover fieldset": {
//                     borderColor: "#D9D9D9",
//                   },

//                   // 🔹 Prevent border color change on focus
//                   "&.Mui-focused fieldset": {
//                     borderColor: "#D9D9D9",
//                   },
//                 },

//                 // Placeholder styling
//                 "& .MuiInputBase-input::placeholder": {
//                   fontSize: "12px",
//                   fontFamily: "Akkurat-Pro",
//                   fontWeight: 400,
//                   color: "#B0B0B0",
//                   opacity: 1,
//                 },
//               }}
//             />

//             {errors.remarks && (
//               <Typography sx={{ color: "red" }}>{errors.remarks}</Typography>
//             )}
//           </Box>

//           {/* SUBMIT BUTTON */}
//           <Grid container spacing={9}>
//             <Button
//               onClick={() => {userLoged? navigate("/landing-page"):
//                 navigate("/");
//               }}
//               sx={{
//                 width: "12rem",
//                 height: "2.5rem",
//                 borderRadius: "1.75rem",
//                 background: "#0036DD",
//                 color: "#FFF",
//                 textTransform: "none",
//               }}
//             >
//               Back
//             </Button>
//             <Button
//               onClick={handleSubmit}
//               sx={{
//                 width: "12rem",
//                 height: "2.5rem",
//                 borderRadius: "1.75rem",
//                 background: "#0036DD",
//                 color: "#FFF",
//                 textTransform: "none",
//               }}
//             >
//               Submit
//             </Button>
//           </Grid>

//           {/* Notifications */}
//           <Notification
//             open={notif.open}
//             success={notif.success}
//             text={notif.text}
//             onClose={() => setNotif((p) => ({ ...p, open: false }))}
//           />

//           {/* Loader */}
//           <GlassLoaderOverLay open={loading} />
//           <SuccessBanner
//             open={showSuccessBanner}
//             message={bannerMessage}
//             status={showErrorBanner}
//           />
//         </Box>
//       </Box>
//     </Box>
//   );
// }
import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  MenuItem,
  Button,
  FormControl,
  RadioGroup,
  Radio,
  FormControlLabel,
  Grid,
  Checkbox,
  FormGroup,
  Modal,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import DevOpsandSRE from "../assets/images/DevOpsandSRE.png";
import logo from "../assets/images/logo.svg";
import { ReactComponent as DomainArrowIcon } from "../assets/images/Vector.svg";

import { useApi } from "../api/useApi";
import { AnimatePresence, motion } from "framer-motion";
import Notification from "./Notification";
import GlassLoaderOverLay from "./GlassLoader";
import { API_PATH } from "../environments";
import PhoneInput from "react-country-phone-input";
import "react-country-phone-input/lib/style.css";
import { phonePatterns } from "./PhonePatterns";

const SuccessBanner = ({ open, message, status }) => (
  <AnimatePresence>
    {open && (
      <motion.div
        initial={{ y: 50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 50, opacity: 0 }}
        transition={{ duration: 0.4, ease: "easeOut" }}
        style={{
          position: "fixed",
          bottom: "2rem",
          left: "35%",
          transform: "translateX(-50%)",
          display: "inline-flex",
          alignItems: "center",
          gap: "1rem",
          borderRadius: "1rem",
          border: status ? "1px solid #eb3d2e" : "1px solid #00A300",
          background: status ? "#df4c4c" : "#016100",
          color: "#FFFFFF",
          fontFamily: "Akkurat-Bold, sans-serif",
          fontSize: "0.9rem",
          padding: "0.75rem 1.25rem",
          zIndex: 2000,
          boxShadow: "0 2px 10px rgba(0,0,0,0.25)",
        }}
      >
        <span>{message}</span>
      </motion.div>
    )}
  </AnimatePresence>
);

export default function ContactUsPopup({ open, onClose, prefillData = {} }) {
  const { request, loading } = useApi();

  const [phoneNumber, setPhoneNumber] = useState(prefillData?.phone ?? "");
  const [phoneError, setPhoneError] = useState("");
  const [domainOptions, setDomainOptions] = useState([]);
  const [errors, setErrors] = useState({});
  const [showSuccessBanner, setShowSuccessBanner] = useState(false);
  const [showErrorBanner, setShowErrorBanner] = useState(false);
  const [bannerMessage, setBannerMessage] = useState("");
  const [notif, setNotif] = useState({ open: false, success: true, text: "" });

  const [formData, setFormData] = useState({
    name: prefillData?.name ?? "",
    email: prefillData?.email ?? "",
    domain: prefillData?.userDomain ?? "",
    role: prefillData?.userRole ?? "",
    category: "",
    remarks: "",
    organisation: prefillData?.organisation ?? "",
    jobTitle: prefillData?.jobTitle ?? "",
    emailContact: prefillData?.emailContact,
    phoneContact:prefillData?.phoneContact,
  });

  // Reset form when popup opens with new prefill data
  useEffect(() => {
    if (open) {
      setPhoneNumber(prefillData?.phone ?? "");
      setPhoneError("");
      setErrors({});
      setFormData({
        name: prefillData?.name ?? "",
        email: prefillData?.email ?? "",
        domain: prefillData?.userDomain ?? "",
        role: prefillData?.userRole ?? "",
        category: "",
        remarks: "",
        organisation: prefillData?.organisation ?? "",
        jobTitle: prefillData?.jobTitle ?? "",
        emailContact: false,
        phoneContact: false,
      });
    }
  }, [open]);
  useEffect(()=>{  
   setFormData({
    name: prefillData?.name ?? "",
    email: prefillData?.email ?? "",
    domain: prefillData?.userDomain ?? "",
    role: prefillData?.userRole ?? "",
    category: "",
    remarks:  "",
    organisation: prefillData?.organisation ?? "",
    jobTitle: prefillData?.jobTitle ?? "",
    emailContact: prefillData?.emailContact,
    phoneContact:prefillData?.phoneContact,
  });
    
},[prefillData])

  useEffect(() => {
    request({ url: "/domain-roles", method: "GET" })
      .then((res) => setDomainOptions(res))
      .catch(() =>
        setNotif({
          open: true,
          success: false,
          text: "Failed to load domain options.",
        }),
      );
  }, []);

  function validatePhone(phone, countryCode) {
    const digits = phone.replace(/\D/g, "");
    const entry = phonePatterns[countryCode?.toUpperCase()];
    if (!entry) return null;
    return entry.pattern.test(digits);
  }

  const handlePhoneChange = (value, countryData) => {
    const formattedValue = value?.startsWith("+")
      ? value
      : `+${value}`;

    setPhoneNumber(formattedValue);

    const iso = countryData?.countryCode?.toUpperCase();
    const dialCode = countryData?.dialCode ?? "";

    const localNumber = formattedValue
      .replace(/\D/g, "")
      .slice(dialCode.length);

    const valid = validatePhone(localNumber, iso);

    setPhoneError(
      valid === false
        ? `Invalid ${countryData?.name} number — ${phonePatterns[iso]?.hint}`
        : ""
    );
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleCheckBoxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({ ...prev, [name]: checked }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Full Name is required";
    if (!formData.email.trim()) newErrors.email = "Email is required";
    else if (!/^\S+@\S+\.\S+$/.test(formData.email))
      newErrors.email = "Invalid email format";
    if (!phoneNumber.trim()) newErrors.phone = "Phone number is required";
    else if (phoneError) newErrors.phone = phoneError;
    if (!formData.domain) newErrors.domain = "Domain is required";
    if (!formData.role) newErrors.role = "Role is required";
    if (!formData.organisation)
      newErrors.organisation = "Organisation is required";
    if (!formData.jobTitle) newErrors.jobTitle = "Job Title is required";
    if (!formData.remarks.trim()) newErrors.remarks = "Please enter your query";
    // if (!formData.emailContact && !formData.phoneContact)
    //   newErrors.contactPreference = "Contact Preference is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    const payload = {
      userName: formData.name,
      emailId: formData.email,
      phoneNumber: phoneNumber,
      userDomain: formData.domain,
      domain: formData.category,
      userRole: formData.role,
      remarks: formData.remarks,
      fromContactUs: true,
      userCategory: "user",
      organisation: formData.organisation,
      jobTitle: formData.jobTitle,
      contactPreference:
        formData.emailContact && formData.phoneContact
          ? "Email,Phone"
          : formData.phoneContact
            ? "Phone"
            : formData.emailContact
              ? "Email"
              : "",
    };

    try {
      const response = await fetch(`${API_PATH}/user/add`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      if (response.ok) {
        setBannerMessage(
          "Thank you! Our team will reach out within 24 working hours.",
        );
        setShowErrorBanner(false);
        setShowSuccessBanner(true);
        setTimeout(() => {
          setShowSuccessBanner(false);
          onClose();
        }, 3000);
      } else {
        setShowErrorBanner(true);
        setBannerMessage("Something went wrong. Please try again.");
        setShowSuccessBanner(true);
        setTimeout(() => setShowSuccessBanner(false), 3000);
      }
    } catch {
      setShowErrorBanner(true);
      setBannerMessage("Unable to submit. Try again later.");
      setShowSuccessBanner(true);
      setTimeout(() => setShowSuccessBanner(false), 3000);
    }
  };

  const inputSx = {
    borderRadius: "1.75rem",
    border: "1px solid #E0E0E0",
    px: 2,
    py: 0.5,
    width: "90%",
    height: "25px",
    "& .MuiInputBase-input": { fontSize: "0.82rem" },
    "& input:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 1000px #FFFFFF inset",
      WebkitTextFillColor: "#000",
      caretColor: "#000",
      transition: "background-color 9999s ease-out 0s",
    },
  };

  const labelSx = {
    mb: 0.5,
    fontFamily: "Akkurat-Pro",
    fontSize: { xs: "0.8rem", lg: "0.75rem", xl: "0.9rem" },
    color: "#525252",
  };

  const errorSx = { color: "red", fontSize: "0.75rem",marginLeft:'5px' };

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Box
        sx={{
          width: { xs: "85vw", sm: "85vw", md: "75vw" },
          height: "83vh",
          maxHeight: "92vh",
          borderRadius: "1.25rem",
          border: "1px solid #E0E0E0",
          backgroundColor: "#FFF",
          display: "flex",
          flexDirection: "column",
          outline: "none",
          overflowY: "auto",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            px: 3,
            pt: 2.5,
            pb: 1.5,
            borderBottom: "1px solid #F0F0F0",
          }}
        >
          <Box>
            <Box
              component="img"
              src={logo}
              alt="Sandhata Logo"
              sx={{
                width: "120px",
                height: "28px",
                objectFit: "contain",
                mb: 0.25,
              }}
            />
            <Typography
              sx={{
                color: "#0036DD",
                fontFamily: "Akkurat-Bold",
                fontSize: "14px",
                lineHeight: 1.3,
              }}
            >
              DevOps and SRE Compass
            </Typography>
            <Typography
              sx={{
                color: "#525252",
                fontFamily: "Akkurat-Pro",
                fontSize: "11px",
              }}
            >
              Fill out the form below and we'll get back to you within 24
              working hours.
            </Typography>
          </Box>
          <IconButton onClick={onClose} size="small">
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
       
        {/* Right form */}
        <Box sx={{ px: 3, pt: 2, pb: 2.5 }}>
          <Grid container spacing={{ xs: 1, sm: 12 }}>
            <Grid
              item
              xs={12}
              sm={6}
              sx={{ width: { xs: "100%", sm: "40%" }, marginBottom: "20px", marginLeft: { xs: 0, sm: "20px" } }}
            >
              {/* Full Name */}
              <Typography sx={labelSx}>Full Name*</Typography>
              <TextField
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder=""
                variant="standard"
                slotProps={{ input: { disableUnderline: true } }}
                sx={inputSx}
                disabled ={prefillData?.isUserLoged&&prefillData?.name}
              />
              {errors.name && (
                <Typography sx={errorSx}>{errors.name}</Typography>
              )}
            </Grid>

            {/* Email */}
            <Grid
              item
              xs={12}
              sm={6}
              sx={{ width: { xs: "100%", sm: "46%" }, marginBottom: "20px" }}
            >
              <Typography sx={labelSx}>Business Email*</Typography>
              <TextField
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder=""
                variant="standard"
                slotProps={{ input: { disableUnderline: true } }}
                sx={inputSx}
                disabled={prefillData?.isUserLoged&&prefillData?.email}
              />
              {errors.email && (
                <Typography sx={errorSx}>{errors.email}</Typography>
              )}
            </Grid>
          </Grid>
          <Grid container spacing={{ xs: 1, sm: 12 }}>
            {/* Organisation */}

            <Grid
              item
              xs={12}
              sm={6}
              sx={{ width: { xs: "100%", sm: "40%" }, marginBottom: "20px", marginLeft: { xs: 0, sm: "20px" } }}
            >
              <Typography sx={labelSx}>Organisation*</Typography>
              <TextField
                name="organisation"
                value={formData.organisation}
                onChange={handleChange}
                placeholder=""
                variant="standard"
                slotProps={{ input: { disableUnderline: true } }}
                sx={inputSx}
              />
              {errors.organisation && (
                <Typography sx={errorSx}>{errors.organisation}</Typography>
              )}
            </Grid>

            {/* Job Title */}
            <Grid
              item
              xs={12}
              sm={6}
              sx={{ width: { xs: "100%", sm: "46%" }, marginBottom: "20px" }}
            >
              {" "}
              <Typography sx={labelSx}>Job Title*</Typography>
              <TextField
                name="jobTitle"
                value={formData.jobTitle}
                onChange={handleChange}
                placeholder=""
                variant="standard"
                slotProps={{ input: { disableUnderline: true } }}
                sx={inputSx}
              />
              {errors.jobTitle && (
                <Typography sx={errorSx}>{errors.jobTitle}</Typography>
              )}
            </Grid>
          </Grid>
          <Grid container spacing={{ xs: 1, sm: 12 }}>
            {/* Phone */}
            <Grid
              item
              xs={12}
              sm={6}
              sx={{ width: { xs: "100%", sm: "40%" }, marginBottom: "20px", marginLeft: { xs: 0, sm: "20px" } }}
            >
              <Typography sx={labelSx}>Phone Number*</Typography>
              <PhoneInput
                country="us"
                value={phoneNumber}
                onChange={handlePhoneChange}
                enableSearch={true}
                countryCodeEditable={false}
                disabled={prefillData?.isUserLoged&&prefillData?.phone}
                inputStyle={{
                  width: "95%",
                  borderRadius: "18px",
                  fontSize: "15px",
                }}
                buttonStyle={{
                  borderRadius: "18px 0 0 18px",
                  borderRight: "none",
                }}
                containerStyle={{ width: "100%" }}
              />
              {errors.phone && (
                <Typography sx={errorSx}>{errors.phone}</Typography>
              )}
            </Grid>

            {/* Contact Preference */}
            <Grid
              item
              xs={12}
              sm={6}
              sx={{ width: { xs: "100%", sm: "46%" }, marginBottom: "20px" }}
            >
               <Typography sx={labelSx}>Domain*</Typography>
              <TextField
                select
                name="domain"
                value={formData.domain}
                onChange={handleChange}
                variant="standard"
                disabled={prefillData?.isUserLoged&&prefillData?.userDomain}
                SelectProps={{ IconComponent: DomainArrowIcon }}
                slotProps={{ input: { disableUnderline: true } }}
                sx={{
                  ...inputSx,
                  "& .MuiSelect-icon": {
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    width: "0.7rem",
                    height: "0.8rem",
                    pointerEvents: "none",
                  },
                }}
              >
                <MenuItem
                  value=""
                  sx={{ fontSize: "0.75rem", color: "#525252" }}
                >
                  Choose one option
                </MenuItem>
                {domainOptions.map((opt) => (
                  <MenuItem
                    key={opt.roleName}
                    value={opt.roleName}
                    sx={{ fontSize: "0.75rem", color: "#525252" }}
                  >
                    {opt.roleName}
                  </MenuItem>
                ))}
              </TextField>
              {errors.domain && (
                <Typography sx={errorSx}>{errors.domain}</Typography>
              )}
            </Grid>
          </Grid>
          {/* Domain */}
          <Grid container spacing={{ xs: 1, sm: 12 }}>
            <Grid
              item
              xs={12}
              sm={6}
              sx={{ width: { xs: "100%", sm: "40%" }, marginBottom: "20px", marginLeft: { xs: 0, sm: "20px" } }}
            >
              <FormControl>
                <Typography sx={labelSx}>Contact Preference (Optional)</Typography>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={formData.emailContact}
                        onChange={handleCheckBoxChange}
                        name="emailContact"

                      />
                    }
                    label="Email"
                    sx={{
                      color: "#525252",
                      "& .MuiTypography-root": {
                        fontFamily: "Akkurat",
                        fontSize: "0.75rem",
                      },
                    }}
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={formData.phoneContact}
                        onChange={handleCheckBoxChange}
                        name="phoneContact"
                      />
                    }
                    label="Phone"
                    sx={{
                      color: "#525252",
                      "& .MuiTypography-root": {
                        fontFamily: "Akkurat",
                        fontSize: "0.75rem",
                      },
                    }}
                  />
                </FormGroup>
              </FormControl>
              {errors.contactPreference && (
                <Typography sx={errorSx}>{errors.contactPreference}</Typography>
              )}
             
            </Grid>

            {/* Role */}
            <Grid
              item
              xs={12}
              sm={6}
              sx={{ width: { xs: "100%", sm: "40%" }, marginBottom: "20px" }}
            >
              <Typography sx={labelSx}>Role*</Typography>
              <FormControl disabled={prefillData?.isUserLoged&&prefillData?.userRole}>
                <RadioGroup
                  name="role"
                  value={formData.role}
                  onChange={handleChange}
                  sx={{ display: "flex", flexDirection: "column" }}
                >
                  {["Manager", "Technical"].map((r) => (
                    <FormControlLabel
                      key={r}
                      value={r}
                      control={<Radio />}
                      label={r}
                      disabled={prefillData?.isUserLoged&&prefillData?.userRole}
                      sx={{
                        color: "#525252",
                        "& .MuiTypography-root": {
                          fontFamily: "Akkurat",
                          fontSize: "0.75rem",
                        },
                      }}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
              {errors.role && (
                <Typography sx={errorSx}>{errors.role}</Typography>
              )}
            </Grid>
          </Grid>
          {/* Query */}
          <Box sx={{ mb: 2 }}>
            <Typography
              sx={{
                mb: 0.5,
                color: "#525252",
                fontSize: "12px",
                fontFamily: "Akkurat-Pro",
                marginLeft: { xs: 0, sm: "20px" },
              }}
            >
              How can we help you?*
            </Typography>
            <TextField
              multiline
              minRows={3}
              name="remarks"
              value={formData.remarks}
              onChange={handleChange}
              placeholder="Can Enter upto 255 characters"
              sx={{
                width: { xs: "100%", sm: "96%" }, marginLeft: { xs: 0, sm: "20px" },
                "& .MuiOutlinedInput-root": {
                  borderRadius: "0.75rem",
                  "& fieldset": { borderColor: "#393838" },
                  "&:hover fieldset": { borderColor: "#D9D9D9" },
                  "&.Mui-focused fieldset": { borderColor: "#D9D9D9" },
                },
                "& .MuiInputBase-input::placeholder": {
                  fontSize: "12px",
                  color: "#B0B0B0",
                  opacity: 1,
                },
              }}
            />
            {errors.remarks && (
              <Typography sx={{color: "red", fontSize: "0.75rem",marginLeft:'25px'}}>{errors.remarks}</Typography>
            )}
          </Box>

          {/* Buttons */}
          <Box sx={{ display: "flex", gap: 2, px: { xs: 0, sm: "20px" }, justifyContent: "space-between" }}>
              <Button
                onClick={onClose}
                sx={{
                  flex: { xs: 1, sm: "none" },
                  width: { xs: "auto", sm: "10rem" },
                  height: "2.5rem",
                  borderRadius: "1.75rem",
                  border: "1px solid #0036DD",
                  color: "#0036DD",
                  textTransform: "none",
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleSubmit}
                sx={{
                  flex: { xs: 1, sm: "none" },
                  width: { xs: "auto", sm: "10rem" },
                  height: "2.5rem",
                  borderRadius: "1.75rem",
                  background: "#0036DD",
                  color: "#FFF",
                  textTransform: "none",
                }}
              >
                Submit
              </Button>
          </Box>

          <Notification
            open={notif.open}
            success={notif.success}
            text={notif.text}
            onClose={() => setNotif((p) => ({ ...p, open: false }))}
          />
          <GlassLoaderOverLay open={loading} />
          <SuccessBanner
            open={showSuccessBanner}
            message={bannerMessage}
            status={showErrorBanner}
          />
        </Box>
      </Box>
    </Modal>
  );
}